export const companyText = (company: any) =>
  `${company.name} - ${company.type} - ${company.cvr} - ${company.status}`
